// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bu80","importantInfo":"styles_importantInfo__1OdKO"};